import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchResultSaved extends DomainEvent<Match> {}
export class RefreshMatchResultSaved extends MatchResultSaved {}
